// Material UI
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";

import brands from "../../../../Utilities/Brands"

export const generateForm = (
  phone,
  setPhone,
  email,
  setEmail,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  campaignId,
  setCampaignId,
  zip,
  setZip,
) => {
  const formLabels = [
    {
      Label: "First Name",
      Element: "TextField",
      Value: firstName,
      Setter: setFirstName,
    },
    {
      Label: "Last Name",
      Element: "TextField",
      Value: lastName,
      Setter: setLastName,
    },
    {
      Label: "Email",
      Element: "TextField",
      Value: email,
      Setter: setEmail,
    },
    {
      Label: "Phone Number",
      Element: "TextField",
      Value: phone,
      Setter: setPhone,
    },
    {
      Label: "Zip",
      Element: "TextField",
      Value: zip,
      Setter: setZip,
    },
    {
      Label: "Brand ID",
      Element: "FormControl",
      Value: campaignId,
      Setter: setCampaignId,
      Data: <>
      <option value="" />
      {["KLS", "SF", "PDC", "PIS", "SPR", "PRR"].map((card, idx) => {
        let campaignId = "";
        switch (card) {
          case "KLS":
            campaignId = 2972;
            break;
          case "SF":
            campaignId = 2994;
            break;
          case "PDC":
            campaignId = 2974;
            break;
          case "PIS":
            campaignId = 2966;
            break;
          case "SPR":
            campaignId = 3005;
            break;
          case "PRR":
            campaignId = 3026;
            break;
          default:
            return null;
        }
        return (
          <option key={idx} value={campaignId}>
            {card}
          </option>
        );
      })}
    </>
    },
  ];

  return formLabels.map(
    ({ Label, Element, Type, Data, Value, Setter }, idx) => {
      switch (Element) {
        case "TextField":
          return (
            <TextField
              id="outlined-full-width"
              className="input-el"
              label={Label}
              type={Type}
              style={{ margin: 8, width: "14rem" }}
              fullWidth={false}
              margin="normal"
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              value={Value}
              onChange={(e) => Setter(e.target.value)}
            />
          );
        case "FormControl":
          return (
            <FormControl
              variant="outlined"
              style={{ margin: 8, width: "14rem" }}
              value={Value}
              onChange={(e) => Setter(e.target.value)}
            >
              <InputLabel htmlFor="outlined-age-native-simple">
                {Label}
              </InputLabel>
              <Select
                native={true}
                label={Label}
                inputProps={{
                  name: `${Label.toLowerCase()}`,
                  id: `outlined-${Label.toLowerCase()}-native-simple`,
                }}
              >
                {Data}
              </Select>
            </FormControl>
          );
        default:
          return null;
      }
    }
  );
};

export const generateNewOrderForm = (
  email,
  setEmail,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  brandId,
  setBrandId,
  zip,
  setZip,
) => {
  const formLabels = [
    {
      Label: "First Name",
      Element: "TextField",
      Value: firstName,
      Setter: setFirstName,
    },
    {
      Label: "Last Name",
      Element: "TextField",
      Value: lastName,
      Setter: setLastName,
    },
    {
      Label: "Email",
      Element: "TextField",
      Value: email,
      Setter: setEmail,
    },
    {
      Label: "Zip",
      Element: "TextField",
      Value: zip,
      Setter: setZip,
    },
    {
      Label: "Brand ID",
      Element: "FormControl",
      Value: brandId,
      Setter: setBrandId,
      Data: <>
      <option value="" />
        {brands.map((card, idx) => {
          let brandId = "";
          switch (card.brand) {
            case "KLS":
              brandId = card._id;
              break;
            case "SF":
              brandId = card._id;
              break;
            case "PDC":
              brandId = card._id;
              break;
            case "PIS":
              brandId = card._id;
              break;
            case "SPR":
              brandId = card._id;
              break;
            case "PRR":
              brandId = card._id;
              break;
            case "QPR":
              brandId = card._id;
              break;
            case "PF":
              brandId = card._id;
              break;
            default:
              return null;
          }
          return (
            <option key={idx} value={brandId}>
              {card.brand}
            </option>
          );
        })}
    </>
    },
  ];

  return formLabels.map(
    ({ Label, Element, Type, Data, Value, Setter }, idx) => {
      switch (Element) {
        case "TextField":
          return (
            <TextField
              id="outlined-full-width"
              className="input-el"
              label={Label}
              type={Type}
              style={{ margin: 8, width: "14rem" }}
              fullWidth={false}
              margin="normal"
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              value={Value}
              onChange={(e) => Setter(e.target.value)}
            />
          );
        case "FormControl":
          return (
            <FormControl
              variant="outlined"
              style={{ margin: 8, width: "14rem" }}
              value={Value}
              onChange={(e) => Setter(e.target.value)}
            >
              <InputLabel htmlFor="outlined-age-native-simple">
                {Label}
              </InputLabel>
              <Select
                native={true}
                label={Label}
                inputProps={{
                  name: `${Label.toLowerCase()}`,
                  id: `outlined-${Label.toLowerCase()}-native-simple`,
                }}
              >
                {Data}
              </Select>
            </FormControl>
          );
        default:
          return null;
      }
    }
  );
};

